import {Component, OnInit} from '@angular/core';
import { GlobalServiceService } from './global-service.service';

@Component({
  selector: 'app-subheader',
  templateUrl: './subheader.component.html',
  styleUrls: ['./subheader.component.css']
})
export class SubheaderComponent implements OnInit {
  height: number;
  proportion: number = 0.261;
  width: number;

  constructor(private service: GlobalServiceService) {}

  ngOnInit(){
   this.onResize();
  }


  onResize(){
    this.calculateAdaptiveHeight();
   this.height = this.service.getHeight(this.proportion);
  }

  calculateAdaptiveHeight(){
    let width = $(window).width();
    let adaptedWidth;
    if (width >= 1600) {
      adaptedWidth = width;
    } else if (width < 1600 && width >= 1200) {
      adaptedWidth = width * 1.13;
    } else if (width < 1300 && width >= 785){
      adaptedWidth = width * 1.2;
    } else {
      adaptedWidth = width * 1.5;
    }

    this.service.setWidth(adaptedWidth);
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/subheader.component.ts